import { useNavigate } from 'react-router-dom';
import type { ApprovalItem } from '@/utils/dashboard';
import StatusBadge from '@/components/base/StatusBadge';
import Button from '@/components/base/Button';

const typeIcon: Record<string, string> = {
  Invoice: 'ri-file-text-line',
  'Payment batch': 'ri-stack-line',
  Content: 'ri-movie-line',
  Contract: 'ri-file-paper-2-line',
};

export default function ApprovalsPanel({ items }: { items: ApprovalItem[] }) {
  const navigate = useNavigate();
  return (
    <div className="divide-y divide-background-100">
      {items.length === 0 ? (
        <p className="px-5 py-6 text-center text-sm text-foreground-500">Nothing waiting for approval.</p>
      ) : null}
      {items.map((item) => (
        <button
          type="button"
          key={item.id}
          onClick={() => item.link && navigate(item.link)}
          className="flex w-full items-start gap-3 px-5 py-3.5 text-left cursor-pointer hover:bg-background-100"
        >
          <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800 text-base">
            <i className={typeIcon[item.type] ?? 'ri-checkbox-circle-line'} />
          </span>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <span className="text-[10px] font-label font-semibold uppercase tracking-wider text-foreground-400">
                {item.type}
              </span>
              <span className="text-[10px] text-foreground-400">· {item.due}</span>
            </div>
            <p className="mt-0.5 text-sm font-medium text-foreground-950 truncate">
              {item.title}
            </p>
            <p className="text-xs text-foreground-500 truncate">{item.detail}</p>
          </div>
          <div className="flex shrink-0 flex-col items-end gap-1.5">
            <span className="text-sm font-medium text-foreground-900">{item.amount}</span>
            <StatusBadge status={item.status} />
          </div>
        </button>
      ))}
      <div className="px-5 py-3">
        <Button
          variant="outline"
          size="sm"
          className="w-full"
          onClick={() => navigate('/invoices')}
        >
          Open approval queue
        </Button>
      </div>
    </div>
  );
}